import { updateProductCache, setCountry, destroySelection, updateLanguage } from "../shop/connect";
import render from "../shop/render";
import { getCookie } from "../util/dom";
import cart from "../partials/top/cart";
import voucher from "../partials/top/voucher";
import addToBagListener from "../partials/list/productItem";
import completeSystemSlider from "../components/sliders/complete-system";
import listing from "../components/interstellar/listing";
import store from "../shop/store";
import { displayCountryModal } from "../partials/top/country";
import geTracking from "../components/ge-tracking";
import flexibleVideo from "../components/flexible-video";
import pfasInit, { removePfasProductFromCart } from "../components/pfas";
export default {
  init: function init() {
    geTracking();
    cart();
    voucher();
    addToBagListener();
    completeSystemSlider.init();
    listing.init();
    flexibleVideo();
  },
  finalize: function finalize() {
    // Update selection language if not the same at the site's language
    $(window).on("store.setCountry", function () {
      var _store$getState = store.getState(),
        escStore = _store$getState.store;
      if (escStore && escStore.language && escStore.language !== window.sitewide.language) {
        updateLanguage(escStore.language);
      }
    });
    $(window).on("store.productCache", function (e, renderedStore) {
      pfasInit();
      removePfasProductFromCart();
    });
    $(window).on("store.changeCountry", function (e, renderedStore) {
      removePfasProductFromCart();
    });
    setCountry();
    updateProductCache();
    displayCountryModal();
    if (getCookie("receiptRendered") && !(window.tokens && window.tokens.debug)) {
      destroySelection();
    }
    render();
    $("html").addClass("is-loaded");
    $(".js-search-form").on("submit", function () {
      var keyword = document.getElementById("js-search-input").value;
      if (!keyword) {
        return false;
      }
      document.getElementById("js-search-input").value = keyword.replace(/(<([^>]+)>)/gi, "");
    });
    var links = $(document).find(".js-anchorLink");
    if (links.length) {
      links.off("click").on("click", function (e) {
        var targetLink = $(this).attr("href");
        if (targetLink && $(targetLink).length) {
          e.preventDefault();
          scrollToSection($(targetLink));
        }
      });
    }
    var disabledLink = $(document).find(".js-disabledOnClick");
    if (disabledLink.length) {
      disabledLink.removeClass("is-loading disabled");
      disabledLink.prop("disabled", false);
      disabledLink.off("click").on("click", function (e) {
        var btn = $(this).find("button");
        if (btn.length) {
          btn.addClass("is-loading disabled");
          btn.prop("disabled", true);
        }
      });
    }
    $(window).on("load", function () {
      try {
        if (window.location.hash !== null && window.location.hash !== "") {
          var hash = window.location.hash.substring(1);
          var target = $("#" + hash);
          if (target.length) {
            scrollToSection(target);
          }
        }
      } catch (error) {
        // Do nothing
      }
    });
  }
};
export var scrollToSection = function scrollToSection(targetEl) {
  if (!targetEl.length) return;
  var navHeight = 0;
  if (matchMedia("screen and (min-width: 992px)").matches) {
    navHeight = $("#js-nav-menu").height();
  }
  var newScrollPos = targetEl.offset().top - navHeight;
  $("html, body").animate({
    scrollTop: newScrollPos
  }, 500, "linear");
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js